export default (function (endpoint) {
  var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  }).then(response => {
    if (response.ok) {
      return response.json();
    }
    return Promise.reject(new Error("POST: ".concat(endpoint, " - web service returned ").concat(response.status, ", ").concat(response.statusText)));
  });
});